// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jwji","textarea":"styles_textarea__1Buxz"};